import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
export var Location = function Location() {
  _classCallCheck(this, Location);

  this.entity_type_id = 21;
  this.attribute_set_id = 22;
  this.status = true;
  this.visible_site = true;
};